import React from 'react';

/*
  Giriş ekranının sol yarısı.

  Ürünün ne yaptığını anlatmak yerine gösteriyor: küçük bir defter,
  altında bakiye çizgisi. Çizgi dekor değil — altındaki rakamın
  girilmediğini, hesaplandığını söylüyor. Aynı kural panelde de geçerli.
*/

const ROWS = [
  { label: 'Konaklama tahsilatı', amount: '+₺48.200', tone: 'pos' },
  { label: 'Tedarikçi ödemesi', amount: '−₺12.750', tone: 'neg' },
  { label: 'Personel maaşı', amount: '−₺21.400', tone: 'neg' },
];

export default function AuthAside() {
  return (
    <aside className="auth-aside">
      <div className="brand">muhasib<span>.</span></div>

      <div className="auth-pitch">
        <h2>Firmalarınızın hesabı tek defterde.</h2>
        <p>
          Gelir ve gideri girin, döviz kuru kendiliğinden çevrilsin,
          ay sonu raporu hazır beklesin.
        </p>

        <div className="auth-ledger" aria-hidden="true">
          {ROWS.map(r => (
            <div className="auth-ledger-row" key={r.label}>
              <span>{r.label}</span>
              <span className={`figure figure-sm ${r.tone === 'pos' ? 'figure-pos' : 'figure-neg'}`}>
                {r.amount}
              </span>
            </div>
          ))}
          <div className="auth-ledger-total">
            <span>Net durum</span>
            <span className="figure figure-sm">₺14.050</span>
          </div>
        </div>
      </div>

      <div style={{ fontSize: 12, color: 'var(--fg-3)' }}>
        Çoklu firma · Çoklu döviz · Fiş arşivi
      </div>
    </aside>
  );
}
